import { ref } from 'vue-demi';
import { v1 as fetcher } from '@teamwork/fetcher';
import { loadLanguageAsync } from '@/i18n';

const user = ref(null);
const isLoading = ref(false);

const fetchCurrentUser = async () => {
  isLoading.value = true;

  user.value = await fetcher(
    'me',
    {
      fullprofile: 1,
      getPreferences: 1,
      cleanPreferences: 1,
      getDefaultViews: 1,
      getAccounts: 1,
      includeAuth: 1,
      includeClockIn: 1,
      includeTeamIds: true,
    },
    ({ data }) => data.person,
  );

  await loadLanguageAsync(user.value.localization.languageCode.toLowerCase());

  isLoading.value = false;
};

export default () => {
  return {
    fetchCurrentUser,
    isLoading,
    user,
  };
};
